<form nz-form style="padding-top:12px;padding-right:12px" autocomplete="off" #form>
  <div nz-row [nzGutter]="['0','0']">
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" #label nzFor="fullName" nzRequired>Họ tên</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="systemUser.fullName" [ngModelOptions]="{standalone: true}" type="text" disabled="true">
        </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" #label nzFor="normalizedUserName" nzRequired>Tên đăng nhập</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="systemUser.normalizedUserName" [ngModelOptions]="{standalone: true}"  type="text" >
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" #label nzFor="passwordHash" nzRequired>Mật khẩu</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="systemUser.passwordHash"  [ngModelOptions]="{standalone: true}"  type="password">
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" #label nzFor="confirmPassword" nzRequired>Nhập lại mật khẩu</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="systemUser.confirmPassword" [ngModelOptions]="{standalone: true}"  type="password">
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24">Hoạt động:</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-radio-group [(ngModel)]="systemUser.isActivity" [ngModelOptions]="{standalone: true}">
              <label nz-radio [nzValue]="true">Có</label>
              <label nz-radio [nzValue]="false">Không</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div> 
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu & Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
        <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
        <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>